export default __webpack_public_path__ + "static/media/task.69774797.svg";